<template>
  <v-card>
    <v-card-title class="primary white--text">
      <h2>
        {{ $t('Solicitar una cita') }}
      </h2>
    </v-card-title>
    <aru-auto-form
      dismiss-button
      @dismiss="dismiss"
      v-model="consultantDate"
      @submit="submit"
      entity="calendar-event"
    ></aru-auto-form>
  </v-card>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import AruAutoForm from '@/components/commons/form/AruAutoForm.vue';

export default {
  components: {
    AruAutoForm,
  },
  data() {
    return {
      defaultFormFields: {
        description: this.$t('Me gustaría concertar una cita para asesorarme sobre ...'),
        name: this.$t('Cita con openGes'),
        type: 'consultant-date',
        status: 'in_progress',
      },
      consultantDate: {},
    };
  },
  mounted() {
    this.consultantDate = this.defaultFormFields;
  },
  methods: {
    submit() {
      apiCtrl.post('/calendar-event', this.consultantDate).then(res => {
        // console.log({SAVED: res});
        this.$emit('closeDialog', res.data.data);
        this.consultantDate = this.defaultFormFields;
      });
    },
    dismiss() {
      // console.log("dismiss");
      this.consultantDate = {};
      this.consultantDate = this.defaultFormFields;
      console.log({ consultantDate: this.consultantDate });
      this.$emit('closeDialog');
    },
  },
};
</script>

<style></style>
